import { useState } from 'react';
import { useUsers } from '../hooks/useUser';
import { useDebounce } from '@/shared/hooks/useDebounce';
import { CreateUserDialog } from '../components/CreateUserDialog';
import { UsersTable } from '../components/UsersTable';
import { LoadingAnimation } from '@/shared/components/LoadingAnimation';

export const UserManagement = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const debouncedSearch = useDebounce(searchTerm, 300);

  const { data: usersPage, isLoading, error } = useUsers(currentPage, pageSize, debouncedSearch.trim() || undefined);

  if (isLoading) {
    return <LoadingAnimation fullScreen />;
  }

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-4">
        <p className="text-red-600">Failed to load users</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">User Management</h1>
          <p className="text-gray-500 mt-1">
            Manage system users and their permissions
          </p>
        </div>
        <CreateUserDialog />
      </div>

      <UsersTable
        users={usersPage?.items ?? []}
        searchTerm={searchTerm}
        onSearchTermChange={(term) => { setSearchTerm(term); setCurrentPage(1); }}
        currentPage={currentPage}
        pageSize={pageSize}
        totalCount={usersPage?.totalCount ?? 0}
        totalPages={usersPage?.totalPages ?? 1}
        onPageChange={setCurrentPage}
        onPageSizeChange={(size) => { setPageSize(size); setCurrentPage(1); }}
      />
    </div>
  );
};